// cart drawer js
jQuery(function($){
  $('.js-menu__open').on('touchend click', function(){
        var menu = $(this).attr('data-menu');

        $(menu).toggleClass('js-menu__expanded');
        $(menu).parent().toggleClass('js-menu__expanded');
		
});

$('.js-menu__context, .js-menu__close').on('touchend click', function(event){
    
    if ( $(event.target).hasClass('js-menu__context') || $(event.target).hasClass('js-menu__close') ) {
         $('.js-menu__expanded').removeClass('js-menu__expanded');
    }
});
  
});


//cart drawer js
$('.site-header__cart').click(function(e){
    e.preventDefault();
    $("body.notoncart").addClass("fix_body");
    $(".cart_drawer").fadeIn();
    setTimeout(function(){
      $(".cart_drawer_data").addClass("showdrawer");
    },1000);
  });
  $("body").on("click",".close",function(){
    $("body").removeClass("fix_body");
    $(".cart_drawer_data").removeClass("showdrawer");
    setTimeout(function(){
      $(".cart_drawer").fadeOut();
    },300);
  });
  $("body").on("click",function(e){
    if ($(e.target).is(".cart_drawer_data") === true || $(e.target).is(".cart_drawer_data  *") === true || $(e.target).is(".site-header__cart") === true || $(e.target).is(".site-header__cart  *") === true  || $(e.target).is(".info_wrapper p.cart__remove") === true  || $(e.target).is(".info_wrapper p.cart__remove *") === true ){

    }else{
      $("body").removeClass("fix_body");
      $(".cart_drawer_data").removeClass("showdrawer");
      setTimeout(function(){
        $(".cart_drawer").fadeOut();
      },300);
    }
  });

//Quantity plus and minus
$('.cart-item-increas').click(function () {
		if ($(this).prev().val() < 3) {
    	$(this).prev().val(+$(this).prev().val() + 1);
		}
});
$('.cart-item-decrease').click(function () {
		if ($(this).next().val() > 1) {
    	if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
  
});

//cccccccccccccccccccccc
$("body").on("click", ".product-form__cart-submit", function(t) {
    t.preventDefault();
    $(this).find(".atc_text").text("Adding...");
    $(this).attr("disabled", !0);
    var $this = $(this);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: $(this).closest("form").serialize(),
      success: function() {
        $.getJSON("/cart",function(t){
           var hqty = t.item_count
             $("#ps").text(hqty);
          if(t.item_count > 0){
            $("#CartCount").removeClass("hide");
          }
     
          var threshold = $(".fpdt_class").val();
          var fpid = $(".fpd_class").val();
          var flag = true;
          var exists = false;
          var items = t.items;
          for(var i=0;i<items.length;i++){
            if(items[i].id == fpid ){
              flag = false;
              exists = true;
            }
          }
         
            $(".js-cart-count span[data-cart-count]").text(t.item_count);
            $(".cart_drawer_data").load(" .cart_drawer_data  > *", function() {
              $this.find(".atc_text").text("Added to cart");
              $("body").addClass("fix_body");
              $(".cart_drawer").fadeIn();
              setTimeout(function() {
                $(".cart_drawer_data").addClass("showdrawer");
              }, 1000) 
              setTimeout(function() {
                $this.attr("disabled", !1);
               // $this.find(".atc_text").text("Add to cart")
              }, 300)
            })

        });
        
      },
      error: function() {
        console.log("error")
      }
    })
  
  })
 
    
$("body").on("click",".cart__row .cart__remove a, .cart_drawer .cart_body .cart__remove a",function(e){
    e.preventDefault();
    var linenumber = $(this).data("line");
    var $this = $(this);
    $(".cart_drawer_data").addClass("enable_overlay");
    $(".cart_drawer").addClass("enable_overlay");
    $.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json', 
      data:{ quantity: 0, line: linenumber },
      success: function(){
        $.getJSON("/cart",function(t){
            var hqty = t.item_count
             $("#ps").text(hqty);
          
          if(t.item_count > 0){
            $("#CartCount").removeClass("hide");
          }
          else{
            $("#CartCount").addClass("hide");
          }
      
          var threshold = $(".fpdt_class").val();
          var fpid = $(".fpd_class").val();
          var flag = true;
          var exists = false;
          var items = t.items;
          for(var i=0;i<items.length;i++){
            if(items[i].id == fpid ){
              flag = false;
              exists = true;
            }
          }
          if(t.item_count == 1 && exists ){
            console.log("here1");
            $.ajax({
              type: 'POST', 
              url: '/cart/change.js',
              dataType: 'json', 
              data:{ quantity: 0, id: fpid },
              success: function() {
                $(".cart_drawer_data").load(" .cart_drawer_data  > *", function() {
                  $(".cart_drawer_data").removeClass("enable_overlay");
                });
                $("#shopify-section-cart-custom-template").load(" #shopify-section-cart-custom-template  > *", function() {
                  $("#shopify-section-cart-custom-template").removeClass("enable_overlay");
                });
                $.getJSON("/cart",function(t){
                  if(t.item_count > 0){
                    $("#CartCount").removeClass("hide");
                  }
                  else{
                    $("#CartCount").addClass("hide");
                  }
               
         
                  $(".js-cart-count span[data-cart-count]").text(t.item_count);
                })
              },
              error: function() {
                console.log("error")
              }
            });
          }
          else if(t.total_price >= threshold && flag){
            console.log("here2");
            $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data:{ quantity: 1, id: fpid },
              success: function() {
                $(".cart_drawer_data").load(" .cart_drawer_data  > *", function() {
                  $(".cart_drawer_data").removeClass("enable_overlay");
                });
                $("#shopify-section-cart-custom-template").load(" #shopify-section-cart-custom-template  > *", function() {
                  $("#shopify-section-cart-custom-template").removeClass("enable_overlay");
                });
                $.getJSON("/cart",function(t){
                  if(t.item_count > 0){
                    $("#CartCount").removeClass("hide");
                  }
                  else{
                    $("#CartCount").addClass("hide");
                  }
                  if(t.item_count > 99){
                    $("#CartCount span[data-cart-count]").addClass("above99");
                  }
                  else{
                    $("#CartCount span[data-cart-count]").removeClass("above99");
                  }
                  $(".js-cart-count span[data-cart-count]").text(t.item_count);
                })
              },
              error: function() {
                console.log("error")
              }
            });
          }
  
          else{
            console.log("here4");
            
            $(".js-cart-count span[data-cart-count]").text(t.item_count);
            $(".cart_drawer_data").load(" .cart_drawer_data  > *", function() {
              $(".cart_drawer_data").removeClass("enable_overlay");
            })
            $("#shopify-section-cart-custom-template").load(" #shopify-section-cart-custom-template  > *", function() {
              $("#shopify-section-cart-custom-template").removeClass("enable_overlay");
            });
            
          }

		
        });
      },
      error:function(){
        console.log("error");
      },
    });
  
  });


//total minus click price calculation js
$("body").on("click",".cart-item-decrease",function(){
    var current =parseInt($(this).parents(".cart__qty").find(".cart__qty-input").val());
    var $this=$(this);
    //alert(current);

    if(current > 1){
      current= Math.max(current - 1, 1);
      $(this).parents(".cart__qty").find(".cart__qty-input").attr("value",current);
      $(".cart_drawer_data").addClass("enable_overlay");
      $("#shopify-section-cart-custom-template").addClass("enable_overlay");
      $.ajax({
        type: 'POST', 
        url: '/cart/update.js',
        dataType: 'json', 
        data: $this.closest("form").serialize(),
        success: function(){
          $.getJSON("/cart",function(t){
            var hqty = t.item_count
             $("#ps").text(hqty);
            if(t.item_count > 0){
              $("#CartCount").removeClass("hide");
            }
     
            var threshold = $(".fpdt_class").val();
            var fpid = $(".fpd_class").val();
            var flag = true;
            var exists = false;
            var items = t.items;
            for(var i=0;i<items.length;i++){
              if(items[i].id == fpid ){
                flag = false;
                exists = true;
              }
            }
            console.log(t.total_price);
          
              console.log("here4");
              $(".js-cart-count span[data-cart-count]").text(t.item_count);
              $(".cart_drawer_data").load(" .cart_drawer_data  > *", function() {
                $(".cart_drawer_data").removeClass("enable_overlay");
                //alert('here');
               
              })
              $("#shopify-section-cart-custom-template form").load(" #shopify-section-cart-custom-template form  > *", function() {
                $("#shopify-section-cart-custom-template").removeClass("enable_overlay");
               
              });

          });
        },
        error:function(){
          console.log("error");
        },
      });
    }
  
  });

//total Plus click price calculation js
$("body").on("click",".cart-item-increas",function() {
    var current =parseInt($(this).parents(".cart__qty").find(".cart__qty-input").val());
    var $this=$(this);
    //alert(current);

  
     current=current+1;
      $(this).parents(".cart__qty").find(".cart__qty-input").attr("value",current);
      $(".cart_drawer_data").addClass("enable_overlay");
      $("#shopify-section-cart-custom-template").addClass("enable_overlay");
      $.ajax({
        type: 'POST', 
        url: '/cart/update.js',
        dataType: 'json', 
        data: $this.closest("form").serialize(),
        success: function(){
          $.getJSON("/cart",function(t){
            var hqty = t.item_count
             $("#ps").text(hqty);
               //console.log(hqty);
            if(t.item_count > 0){
              $("#CartCount").removeClass("hide");
            }
     
            var threshold = $(".fpdt_class").val();
            var fpid = $(".fpd_class").val();
            var flag = true;
            var exists = false;
            var items = t.items;
            for(var i=0;i<items.length;i++){
              if(items[i].id == fpid ){
                flag = false;
                exists = true;
              }
            }
            console.log(t.total_price);
             
              console.log("here4");
              $(".js-cart-count span[data-cart-count]").text(t.item_count);
              $(".cart_drawer_data").load(" .cart_drawer_data  > *", function() {
                $(".cart_drawer_data").removeClass("enable_overlay");
                
              })
              $("#shopify-section-cart-custom-template form").load(" #shopify-section-cart-custom-template form  > *", function() {
                $("#shopify-section-cart-custom-template").removeClass("enable_overlay");
              });

          });
        },
        error:function(){
          console.log("error");
        },
      });
   
  });